import React from 'react';
import InspectionPlanAddEditModal from './inspectionplan-add-edit';
 
import { MODAL_TYPES } from 'Feature/components/app-modals';

const { INSPECTIONPLAN_ADD_EDIT } = MODAL_TYPES;

const InspectionPlanModals = () => {
  return (
    <>
      <InspectionPlanAddEditModal modalId={INSPECTIONPLAN_ADD_EDIT} />
      
    </>
  );
};

export default InspectionPlanModals;
